<template>
    <div class="container_pop">
        <div class="close-view">
            <img src="../assets/ai/close.png" alt="" srcset="" @click="goBack()">
        </div>
        <video :src="videoPath" playsinline autoplay loop></video>
    </div>
</template>
<script>
    export default {
        name: 'pagePop',
        props: {
            type: Number,
            status: String,
        },
        data() {
            return {
                videoPath: '',
                video1:require('@/assets/loading.mp4'),
                video2:require('@/assets/fitting.mp4'),
            }
        },
        methods: {
            goBack() {
                this.$emit('goBack');
            } 
        },
        created() {
            if(this.status === 'dimension'){
              this.videoPath = this.video1;
            }else if(this.status === 'fitting'){
                this.videoPath = this.video2;
                
            }
        },
        // 例如这个函数就会在组件挂载完成后被调用
        mounted() {
              
        }
    }
</script>
<style src="" scoped lang="less">
    .container_pop{
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, .5);
        z-index: 10000;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        align-content: center;
        justify-content: center;
        backdrop-filter: blur(1px);
        flex-direction: column;
        flex-wrap: wrap;
        .close-view{
            text-align: right;
            height: .8rem;
        }
        img{
            width: 1.12rem;
            height: 1.12rem;
            position: relative;
            left: 0.6rem;
        }
        video{
            width: 12.2rem;
        }
    }
</style>